<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="text-flush-left" lang="en-US"><span class="Italic-Style" lang="en-US">We would have every path laid open to women … Were this done … we would see crystallizations more pure and of more various beauty</span>.<span class="Italic-Style" lang="en-US"> We believe the divine energy would pervade nature to a degree unknown in the history of former ages</span>,<span class="Italic-Style" lang="en-US"> and that no discordant collision</span>,<span class="Italic-Style" lang="en-US"> but a ravishing harmony of the spheres</span>,<span class="Italic-Style" lang="en-US"> would ensue</span>.</p>
<p class="text-right-space-after" lang="en-US"><span class="Italic-Style" lang="en-US">—Margaret Fuller</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781504086356-0.vue?47ca8c8c